
import ExpandableZipArea from './ExpandableZipArea.vue';
import FulfillmentOptionDisclaimer from './FulfillmentOptionDisclaimer.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import FulfillmentOptionsStockInfo from './FulfillmentOptionsStockInfo.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';

@Component({
	name: 'FulfillmentOptionsFooterShipping',
	components: {
		FulfillmentOptionsStockInfo,
		ExpandableZipArea,
		FulfillmentOptionLink,
		FulfillmentOptionDisclaimer
	}
})
export default class FulfillmentOptions extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	@Get('isInStockForShip')
	readonly isInStockForShip: boolean;

	@Get('inStoreOnly')
	readonly inStoreOnly: boolean;

	@Get('isAvailableOnline')
	readonly isAvailableOnline: boolean;

	@Get('shippingDeliveryDate')
	readonly shippingDeliveryDate: string;

	@Get('shippingError')
	readonly shippingError: string;

	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get stockSubscriptionFormEnabled(): boolean {
		return 	!this.isInStockForShip && 
				!this.inStoreOnly &&
				!this.outOfMarket &&
				this.product.backInStockInfo.isProductEligible &&
				this.hasSelectedVariant &&
				!this.fetchingProduct;
	}

	get disclaimer(): string | null {
		if (this.stockSubscriptionFormEnabled || this.inStoreOnly) {
			return null;
		}

		return this.product.eseText;
	}

	get showEstimatedDelivery() {
		return this.isAvailableOnline && this.isInStockForShip && this.estimatedDelivery;
	}

	get estimatedDelivery() {
		return this.shippingDeliveryDate
			? `Expect it by ${this.shippingDeliveryDate}` : null;
	};

	/* Data
	============================================*/
	showZipArea: boolean = false;

	/* Methods
	============================================*/
	toggleZipArea() {
		this.showZipArea = !this.showZipArea;
	}

	mounted() {
		if (!this.shippingDeliveryDate) {
			this.$store.dispatch('getShippingInfo');
		}
	}
}
